import * as React from 'react'

import { Box, Table, Text } from '@factorialco/deprecated-design-system'
import groupBy from 'lodash/groupBy'

import { observer } from 'mobx-react'

import { ExpensesMappingsCategoriesDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'
import legalEntities from 'modules/core/store/collections/legalEntities'

import taxonomies from 'modules/contracts/store/collections/taxonomies'
import expensesCategoriesContractsTaxonomies from 'modules/payroll_bundle/store/collections/expensesCategoriesContractsTaxonomies'

import ExpenseMappingsRow from './ExpenseMappingsRow'

const ExpensesMappingsTable = () => {
  const { data, loading: categoriesLoading } = useQuery(ExpensesMappingsCategoriesDocument)

  const { loading: mobxLoading } = useAsyncData(
    () =>
      Promise.all([
        taxonomies.fetch(),
        expensesCategoriesContractsTaxonomies.fetch(),
      ]),
    []
  )

  if (categoriesLoading || mobxLoading) return <Loading />

  const expensesCategories = data?.finance.customCategoriesConnection.nodes ?? []

  const taxonomiesByLegalEntity = groupBy(
    taxonomies.filter({ archived: false }),
    (t) => t.attributes.legal_entity_id
  )

  return (
    <Box>
      <Table fullWidth>
        <Table.Head>
          <Table.Row>
            <Table.HeadCell width={200} sticky={{ position: 'left', delimiter: true }}>
              <Text.Normal weight="bold">
                {i18n.t(
                  'app_store_v2.apps.payroll_bundle.settings.external_supplements.expense_category'
                )}
              </Text.Normal>
            </Table.HeadCell>
            {legalEntities.map((legalEntity) => (
              <Table.HeadCell width={200} key={legalEntity.id}>
                <Text.Normal weight="bold">
                  {i18n.t(
                    'app_store_v2.apps.payroll_bundle.settings.external_supplements.title_of_supplement',
                    { legal_entity: legalEntity.attributes.legal_name }
                  )}
                </Text.Normal>
              </Table.HeadCell>
            ))}
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {expensesCategories.map((expensesCategory) => (
            <ExpenseMappingsRow
              expensesCategory={expensesCategory}
              legalEntities={legalEntities}
              taxonomiesByLegalEntity={taxonomiesByLegalEntity}
              expensesCategoriesContractsTaxonomies={expensesCategoriesContractsTaxonomies}
              key={expensesCategory.id}
            />
          ))}
        </Table.Body>
      </Table>
    </Box>
  )
}

export default observer(ExpensesMappingsTable)
